// extracted by mini-css-extract-plugin
export default {"root":"dh-tilpasset-bilde-root--tuh_u"};